// extracted by mini-css-extract-plugin
export var root = "MarkdownCaption-module--root--9757b";